
import React from 'react'
import { Grid } from '@mui/material'
import CourseItem from '../Item'
import './demand.scss'
import { Demand } from '../../../../utilities'


function Index() {

    return (
        <div className="demand">
            <div className="content">
                <Grid className='wrapper' container>

                    {
                        Demand.map((item , index) => <CourseItem key={index} data={item} size={3.8} /> )
                    }

                </Grid>
            </div>
        </div>
    )
}

export default Index
